export const feetypeMangementLabel = {
    buttons: {
        add: "추가",
    },
    titles: {
        table: "회비 종류",
        addModal: "등록하기",
    },
};

export const paymentMangementLabel = {
    buttons: {
        search: "검색",
        download: "EXCEL 파일 다운",
    },
    titles: {
        table: "납부 내역",
    },
};